/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_GoalInputs */

const en_us2_profile_editors_eyebrow_goal = /** @type {(inputs: Profile_Editors_Eyebrow_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goal and experience`)
};

const pt_br2_profile_editors_eyebrow_goal = /** @type {(inputs: Profile_Editors_Eyebrow_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo e experiência`)
};

const es_419_profile_editors_eyebrow_goal = /** @type {(inputs: Profile_Editors_Eyebrow_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo y experiencia`)
};

const pt_pt2_profile_editors_eyebrow_goal = /** @type {(inputs: Profile_Editors_Eyebrow_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo e experiência`)
};

const fr_fr2_profile_editors_eyebrow_goal = /** @type {(inputs: Profile_Editors_Eyebrow_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif et expérience`)
};

const de_de2_profile_editors_eyebrow_goal = /** @type {(inputs: Profile_Editors_Eyebrow_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel und Erfahrung`)
};

const it_it2_profile_editors_eyebrow_goal = /** @type {(inputs: Profile_Editors_Eyebrow_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo ed esperienza`)
};

/**
* | output |
* | --- |
* | "Goal and experience" |
*
* @param {Profile_Editors_Eyebrow_GoalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_goal = /** @type {((inputs?: Profile_Editors_Eyebrow_GoalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_GoalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_goal(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_goal(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_goal(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_goal(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_goal(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_goal(inputs)
	return en_us2_profile_editors_eyebrow_goal(inputs)
});
export { profile_editors_eyebrow_goal as "profile-editors.eyebrow_goal" }